<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 首页
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style='display: flex;text-align: center;align-items: center;justify-items: center;justify-content: center'>
            <div
                style='margin-right: 20px;width: 17%;background-color: #5383FF;height: 140px;text-align: center;justify-content: center;color: white;justify-items: center;align-items: center;display: flex;flex-direction: column'>
                <div style='color: white;font-weight: 700;font-size: 40px'>{{ indexData.count }}</div>
                <div style='color: white'>运输车出动次数</div>
            </div>
            <div
                style='margin-right: 20px;width: 17%;background-color: #8D55FF;height: 140px;text-align: center;justify-content: center;color: white;justify-items: center;align-items: center;display: flex;flex-direction: column'>
                <div style='color: white;font-weight: 700;font-size: 40px'>{{ indexData.allCount }}</div>
                <div style='color: white'>园区企业数</div>
            </div>
            <div
                style='margin-right: 20px;width: 17%;background-color: #00FFFF;height: 140px;text-align: center;justify-content: center;color: white;justify-items: center;align-items: center;display: flex;flex-direction: column'>
                <div style='color: white;font-weight: 700;font-size: 40px'>{{ indexData.useCount }}</div>
                <div style='color: white'>合作企业数</div>
            </div>
            <div
                style='margin-right: 20px;width: 17%;background-color: Orange;height: 140px;text-align: center;justify-content: center;color: white;justify-items: center;align-items: center;display: flex;flex-direction: column'>
                <div style='color: white;font-weight: 700;font-size: 40px'>{{ indexData.ratio }}</div>
                <div style='color: white'>覆盖率</div>
            </div>
            <div
                style='margin-right: 20px;width: 17%;background-color: #409eff;height: 140px;text-align: center;justify-content: center;color: white;justify-items: center;align-items: center;display: flex;flex-direction: column'>
                <div style='color: white;font-weight: 700;font-size: 40px'>{{ indexData.value }}</div>
                <div style='color: white'>污水处理量</div>
            </div>

        </div>
        <div style='background-color: white;margin-top: 30px;margin-left: 30px;margin-right: 30px'>
            <div style='padding-left: 30px;padding-top: 30px'>统计表</div>
            <div style='margin-left: 60px;padding-left: 30px;padding-top: 30px;display: flex'>
                <div @click='clickType(1)'
                     id='dayId'
                     style='width: 46px;height: 26px;border: 1px solid #eaeaea;line-height: 26px;text-align: center;background-color: #5383FF;color: white'
                     >日
                </div>
                <div @click='clickType(2)'
                     id='weekId'
                     style='width: 46px;height: 26px;border: 1px solid #eaeaea;;line-height: 26px;text-align: center;'
                    >周
                </div>
                <div @click='clickType(3)'
                     id='monthId'
                     style='width: 46px;height: 26px;border: 1px solid #eaeaea;;line-height: 26px;text-align: center;'
                    >月
                </div>
                <div @click='clickType(4)'
                     id='yearId'
                     style='width: 46px;height: 26px;border: 1px solid #eaeaea;;line-height: 26px;text-align: center;'
                     >年
                </div>
            </div>

            <div class='echart' id='mychart' :style='myChartStyle' style='background-color: white'></div>
        </div>
    </div>
</template>

<script>
import { formatDate, formatDates } from '@/utils/formatDate';
import * as echarts from 'echarts';

export default {
    name: 'basetable',
    data() {
        return {

            infoWindowShow: false,
            longitude: '',
            latitude: '',
            radio: '1',
            fileList: [],
            workType: '',
            value: [],
            options: [],
            query: {
                name: '',
                educationRank: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            cityOptions: [],
            cityIds: [],
            workTypeIds: [],
            roleOptions: [{ 'value': '0', 'label': '班组长' }, { 'value': '1', 'label': '司机' }],
            myChart: {},
            xData: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], //横坐标
            yData: [23, 24, 18, 25, 27, 28, 25], //人数数据
            myChartStyle: { float: 'left', width: '100%', height: '400px' },
            indexData: {
                noUseCount: '1',
                count: '1',
                useCount: '1',
                allCount: '2',
                value: '22.0',
                ratio: '50.0%'

            },


            createForm: {
                'concatPhone': '',
                'concatName': '',
                'name': '',
                'covenantUrl': '',
                'legalPersonUrl': '',
                'orzUrl': '',
                'isCustomerService': '1',
                'provinceId': '',
                'cityId': ''

            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            location: '北京',
            keyword: '',
            xAxis: [],
            alarmData: [0, 0, 0, 0, 0, 0, 0],
            transportationData: [1, 2, 3, 4, 5, 6, 7],
            type: 1

        };
    },
    created() {
        this.getData();
        this.getIndexDetailData();

        // this.getCity();
    },
    mounted() {
        // 挂在完成dom后进行初始化
        // this.initEcharts()
    },

    methods: {
        clickType(type) {
            this.type = type;
            document.getElementById("weekId").style.backgroundColor='#ffffff'
            document.getElementById("weekId").style.color='#666666'

            document.getElementById("yearId").style.backgroundColor='#ffffff'
            document.getElementById("yearId").style.color='#666666'

            document.getElementById("monthId").style.backgroundColor='#ffffff'
            document.getElementById("monthId").style.color='#666666'

            document.getElementById("dayId").style.backgroundColor='#ffffff'
            document.getElementById("dayId").style.color='#666666'
            if (type === 1) {

                document.getElementById("dayId").style.backgroundColor='#5383FF'
                document.getElementById("dayId").style.color='#ffffff'

            } else if (type === 2) {
                document.getElementById("weekId").style.backgroundColor='#5383FF'
                document.getElementById("weekId").style.color='#ffffff'
            } else if (type === 3) {
                document.getElementById("monthId").style.backgroundColor='#5383FF'
                document.getElementById("monthId").style.color='#ffffff'
            } else if (type === 4) {
                document.getElementById("yearId").style.backgroundColor='#5383FF'
                document.getElementById("yearId").style.color='#ffffff'

            }

           this.getIndexDetailData();

        }
        ,
        initEcharts() {
            let that = this;
            const option = {
                title: {
                    text: ''
                },
                legend: {
                    data: ['预警数', '车辆出动数']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },

                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: that.xAxis
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '预警数',
                        type: 'line',
                        data: that.alarmData
                    },
                    {
                        name: '车辆出动数',
                        type: 'line',

                        data: that.transportationData
                    }
                ]
            };

            this.myChart = echarts.init(document.getElementById('mychart'));
            this.myChart.setOption(option);
            //随着屏幕大小调节图表
            window.addEventListener('resize', () => {
                this.myChart.resize();
            });
        }

        ,
        indexMethod(index) {
            return index + 1;
        },
        handlePreview(file) {

        },
        uploadFileCovenant(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.photoUrls = [{ url: that.http.getDownLoadUrl() + res.data.data[0] }];

                    that.form.photoUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    that.createForm.photoUrl = that.http.getDownLoadUrl() + res.data.data[0];

                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileLegalPerson(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.legalPersonUrl = res.data.data;
                    that.form.legalPersonUrl = res.data.data;
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        uploadFileOrzUrl(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.orzUrl = res.data.data;
                    that.form.orzUrl = res.data.data;

                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        }
        ,
        // 获取 easy-mock 的模拟数据
        getData() {
            let that = this;


            this.http.get('/Task/getIndexData', this.query).then(res => {
                    if (res.code == 0) {
                        that.indexData = res.data;


                    }
                },
                err => {

                });
        },
        getIndexDetailData() {
            let that = this;

            this.query.type = this.type;
            this.http.get('/Task/getIndexDetailData', this.query).then(res => {
                    if (res.code == 0) {
                        that.xAxis = res.data.dates;
                        that.transportationData = res.data.dataTransport;
                        that.alarmData = res.data.dataAlarm;
                        that.initEcharts();


                    }
                },
                err => {

                });
        },
        getLocation(e) {
            this.longitude = e.point.lng;
            this.latitude = e.point.lat;
            this.infoWindowShow = true;
            for (let key in e) {
                if (typeof e[key] === 'function') {
                    console.log(key + '()');
                } else {
                    console.log(key + ': ' + e[key]);
                }
            }
        },
        getCity() {
            let that = this;


            this.http.getToken('serviceProvider/getCity', this.query).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        },
        delUserHttp(id) {
            let that = this;
            this.http.post('user/delUserById', { 'id': id, 'status': 1 }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        editUserHttp(params) {
            let that = this;

            this.http.post('user/updateUserPwdByid', params).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        this.editVisible = false;
                        that.$message.success('编辑成功');
                    }
                },
                err => {

                });
        }
        ,
        handleAdd() {
            this.createForm = {};
            this.addVisible = true;
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.createForm = {};
            this.value = [];
            this.addVisible = true;


        },

        addUserHttp() {

            let that = this;
            this.http.postToken('user/createClientAccount', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                }

            });
        }
        ,
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 0) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 2 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('serviceProvider/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.form = {};
            this.form.id = row.id;

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {

            this.editUserHttp(this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.map {
    width: 100%;
    height: 300px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.selectType {
    background-color: #5383FF;
    color: white;
}

.unSelectType {
    background-color: white;
    color: #666666;
}
</style>
